const IFrameMessagingType = {
    Request: "request", //this type should send back an ack
    Ack: "ack", //sent internally - do not queue this type
    Event: "event" //events are fire and forget
};

const IFrameMessagingAction = {
    Ping: "ping", //internal for establishing connection - not sent to callbacks
    Error: "error", //sent for internal error
    ChildLoad: "child_load", //sent for internal event
    ChildDisable: "child_disable", //internal event to cripple current child as it could interfere after ResetFrame due to unload delay - not sent to callbacks
    DocumentReady: "document_ready", //child content should send this for more reliable equivalent to ChildLoad
    CyberSourcePayment: "cybersource_payment",
    FrameInteractionDone: "frame_interaction_done" //close frame or hide frame or redirect parent
};

/*Limited to single child only with single request*/
class IFrameMessagingHelper {
    constructor() {
        this.Enabled = false;
        this.ChildIdentifier = null;
        this.ChildFrame = null;
        this.LinkIsVerified = false;
        this.LinkVerifyTries = 0;
        this.TrustedSource = (location.protocol + "//" + location.host);
        this.BlankSrc = "about:blank";
        this.CallBackOnMessage = null;
        this.CallBackOnCompletion = null;
        this.CallBackOnError = null;
        this.CompletionTimeoutHandle = null;
        this.MessageQueue = [];
    }
    RegisterChild(options) {
        //console.log("register as parent");
        return this.RegisterInternal(options, true);
    }
    RegisterAsChild(options) {
        //console.log("register as child");
        return this.RegisterInternal(options, false);
    }
    RegisterInternal(options, isParent) {
        if (this.IsRegistered()) return false; //we've registered already
        if (!options || typeof (options.onMessage) != "function") return false; //mandatory
        if (isParent && (!options.childIdentifier || !options.contentUrl)) return false; //mandatory
        if (!isParent && (!window.parent || window.parent == window)) return false; //we'll end up talking to ourselves otherwise


        try {
            if (typeof (options.onError) == "function") this.CallBackOnError = options.onError;

            if (isParent) {
                //var matches = $('#' + options.childIdentifier);
                //if (matches.length != 1) return false;
                //var frame = matches.get(0);
                var frame = document.getElementById(options.childIdentifier);
                if (!frame) return false;
                this.ChildIdentifier = options.childIdentifier;
                this.ChildFrame = frame;
                let helperInstance = this;

                try { //nice to have but not essential
                    this.ChildFrame.addEventListener("load", function (ev) { helperInstance.OnLoadOnChild(ev); });
                    //$(this.ChildFrame).on("load", this.OnLoadOnChild);
                }
                catch (error) {

                }
            }

            let helperInstance = this;
            window.addEventListener("message", function (ev) { helperInstance.OnWindowMessage(ev); });
            //$(window).on("message", this.OnWindowMessage);

            this.CallBackOnMessage = options.onMessage;
            if (typeof (options.onCompletion) == "function") {
                this.CallBackOnCompletion = options.onCompletion;
                if (options.completionTimeoutMillis) {
                    this.CompletionTimeoutHandle = window.setTimeout(
                        function () { helperInstance.NotifyCompletionOutcomeIfPending(); }
                        , options.completionTimeoutMillis);
                }
            }

            if (isParent) {
                //updated src if not pre-loaded
                var currSrc = this.ChildFrame.getAttribute("src");
                //var currSrc = $(this.ChildFrame).attr("src");
                if (!currSrc || currSrc == this.BlankSrc) this.ChildFrame.setAttribute("src", options.contentUrl);
                //if(!currSrc || currSrc == this.BlankSrc) $(this.ChildFrame).attr("src", options.contentUrl);  
            }

            this.Enabled = true;
            this.PostPendingMessages(); //trigger link check

            return true;
        }
        catch (error) {
            if (this.CallBackOnError) {
                this.CallBackOnError(error, "IFrameMessagingHelper/RegisterInternal");
            }
        }

        return false;
    }
    ResetFrame(options) {
        if (!this.ChildFrame) return;
        if (this.LinkIsVerified) {
            this.QueueMessage({
                type: IFrameMessagingType.Event,
                action: IFrameMessagingAction.ChildDisable,
                payload: {}
            });
        }

        this.Enabled = false;
        this.LinkIsVerified = false;
        this.LinkVerifyTries = 0;
        this.CallBackOnCompletion = null;
        this.NotifyCompletionOutcomeIfPending(); //should clear the timeout
        this.CallBackOnMessage = null;
        this.MessageQueue = [];

        try { //nice to have but not essential
            this.ChildFrame.removeEventListener("load", this.OnLoadOnChild);
            //$(this.ChildFrame).off("load");
        }
        catch (error) {

        }

        window.removeEventListener("message", this.OnWindowMessage);
        //$(window).off("message");    

        this.ChildFrame.setAttribute("src", this.BlankSrc);
        //$(this.ChildFrame).attr("src", this.BlankSrc);

        this.ChildFrame.ChildIdentifier = null;
        this.ChildFrame.ChildFrame = null;

        this.CallBackOnError = null;
    }
    QueueMessage(messageData) {
        if (!this.Enabled) return false;
        if (!messageData || !messageData.type || !messageData.action) return false; //mandatory
        //TODO: maybe limit to one active request

        this.MessageQueue.push(messageData);
        this.PostPendingMessages();
        return true;
    }
    OnLoadOnChild(loadEvent) {  //make sure child register is called after document ready      
        //console.log("child frame load", loadEvent);
        this.LinkIsVerified = false;
        this.LinkVerifyTries = 0;
        //this.MessageQueue = []; //discard - event is not reliable enough to do this

        //send to self      
        this.ProcessMessageInternal({
            type: IFrameMessagingType.Event,
            action: IFrameMessagingAction.ChildLoad,
            payload: loadEvent
        });
    }
    OnWindowMessage(messageEvent) {
        //console.log("window message", this.ChildIdentifier, messageEvent);
        //if (messageEvent.originalEvent) messageEvent = messageEvent.originalEvent; //for jquery
        if (messageEvent.origin == this.TrustedSource) {
            var messageData = messageEvent.data;

            if (messageData
                && window.document.documentMode
                && typeof (messageData) == "string"
                && messageData.length > 0
                && messageData.trim().charAt(0) == "{") {
                //IE only takes string message
                messageData = JSON.parse(messageData);
                //console.log("IE receive", messageData);
            }

            this.ProcessMessageInternal(messageData);
        }
    }
    ProcessMessageInternal(messageData) {
        if (!this.Enabled) return;
        //console.log("RECEIVE message", this.ChildIdentifier, messageData);

        if (messageData && messageData.action && messageData.type) { //try and filter out messages from plugins

            if (messageData.type == IFrameMessagingType.Ack) {
                this.LinkIsVerified = true;
                this.NotifyCompletionOutcomeIfPending();
            }

            var ackPayload = null;
            if (messageData.action == IFrameMessagingAction.Ping) { //internal action
                if (messageData.type == IFrameMessagingType.Request) {
                    ackPayload = {
                        locationPathName: window.location.pathname //location object will fail to clone
                    };
                }
            }
            else if (messageData.action == IFrameMessagingAction.ChildDisable) {
                if (!this.ChildFrame) {
                    this.Enabled = false; //cripple child
                }
            }
            else {
                var messageCallbackResp = null;
                if (this.CallBackOnMessage) {
                    try {
                        messageCallbackResp = this.CallBackOnMessage(messageData);
                    }
                    catch (error) {
                        if (this.CallBackOnError) {
                            this.CallBackOnError(error, "IFrameMessagingHelper/ProcessMessageInternal/CallBackOnMessage");
                        }
                    }
                }

                if (messageData.type == IFrameMessagingType.Request) {
                    ackPayload = messageCallbackResp;
                }
            }

            if (messageData.type == IFrameMessagingType.Request) { // send the ack - null payload means maybe no one actioned it
                this.PostMessageInternal({
                    type: IFrameMessagingType.Ack,
                    action: messageData.action,
                    payload: ackPayload
                });
            }

            if (messageData.action != IFrameMessagingAction.ChildLoad)
                this.PostPendingMessages(); //trigger link check
        }
    }
    PostPendingMessages() {
        if (!this.Enabled) return;

        if (this.LinkIsVerified) {
            var origLen = this.MessageQueue.length;
            while (this.MessageQueue.length) {
                var messageData = this.MessageQueue.pop();
                this.PostMessageInternal(messageData);

                if (this.MessageQueue.length == origLen) break; //safety
            }
        }
        else if (this.LinkVerifyTries <= (3 + this.MessageQueue.length)) {
            if (this.PostMessageInternal({
                type: IFrameMessagingType.Request,
                action: IFrameMessagingAction.Ping,
                payload: {
                    locationPathName: window.location.pathname //location object will fail to clone
                }
            })) {
                this.LinkVerifyTries = this.LinkVerifyTries + 1;
            }
        }
    }
    PostMessageInternal(messageData) {
        if (!this.Enabled) return false;

        //console.log("POST message", this.ChildIdentifier, messageData);

        //possible security exceptions 
        try {
            if (window.document.documentMode) {
                //IE only takes string message
                messageData = JSON.stringify(messageData);
                //console.log("IE post", messageData);
            }

            //TODO: does jquery expose .postMessage
            if (this.ChildFrame && this.ChildFrame.contentWindow) {
                this.ChildFrame.contentWindow.postMessage(messageData, this.TrustedSource);
            }
            else if (window.parent) {
                window.parent.postMessage(messageData, this.TrustedSource);
            }
        }
        catch (error) {
            if (this.CallBackOnError) {
                this.CallBackOnError(error,"IFrameMessagingHelper/PostMessageInternal");
            }
        }

        return true;
    }
    NotifyCompletionOutcomeIfPending() {
        if (this.CompletionTimeoutHandle) {
            window.clearTimeout(this.CompletionTimeoutHandle);
            this.CompletionTimeoutHandle = null;
        }
        if (typeof (this.CallBackOnCompletion) == "function") {
            try {
                this.CallBackOnCompletion(this.LinkIsVerified);
            }
            catch (error) {
                if (this.CallBackOnError) {
                    this.CallBackOnError(error, "IFrameMessagingHelper/NotifyCompletionOutcomeIfPending/CallBackOnCompletion");
                }
            }
            this.CallBackOnCompletion = null;
            this.Enabled = this.LinkIsVerified;
        }
    }
    IsRegistered() {
        return (typeof (this.CallBackOnMessage) == "function");
    }
    IsReady() {
        return (this.Enabled && this.LinkIsVerified);
    }
    UpdateHeight(newHeight, minHeight) {
        if (!this.Enabled || !this.ChildFrame) return false;
        try {
            //margin may need to be accounted for
            if (!newHeight) newHeight = Math.max(
                //this.ChildFrame.contentDocument.documentElement.scrollHeight, // documentElement values did not seem to work
                //this.ChildFrame.contentDocument.documentElement.offsetHeight, 
                this.ChildFrame.contentDocument?.body?.scrollHeight,
                this.ChildFrame.contentDocument?.body?.offsetHeight
            );
            //newHeight = $(this.ChildFrame.contentDocument.body).outerHeight(true); //doesn't seem work well

            if (minHeight) newHeight = Math.max(newHeight, minHeight);

            if (newHeight) {
                //console.log("updating height", newHeight);
                this.ChildFrame.setAttribute("height", newHeight);
                //$(this.ChildFrame).attr("height", newHeight);              

                return true;
            }
        }
        catch (error) {
            //TODO: could try indirect method via messaging
            if (this.CallBackOnError) {
                this.CallBackOnError(error, "IFrameMessagingHelper/UpdateHeight");
            }
        }

        return false;
    }
};

const IFrameMessaging = new IFrameMessagingHelper();